<template>
  <div class="d-flex align-items-center text-muted">
    <div v-if="audit && audit.user" class="d-flex align-items-center me-2">
      <span v-if="isByVisible" class="mx-1">{{ t('by') }}</span>
      <BaseUserProfileBadge :size="size" :user="audit.user" />
    </div>
    <div class="d-flex flex-wrap text-break">
      <span class="text-nowrap">{{ resolvedDate }},&nbsp;</span>
      <span class="text-nowrap">{{ resolvedTime }} </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType } from 'vue'
import { Audit } from '@/dto/common/audit'
import { shortUsDate, shortUsTime, localShortDate, localShortTime } from '@/helpers/date.helper'
import { BadgeSize } from '@/shared'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  audit: {
    type: Object as PropType<Audit | undefined | null>,
    default: undefined,
  },
  updatedAt: {
    type: String,
    required: true,
  },
  size: {
    type: String as PropType<BadgeSize>,
    default: 'md',
    required: false,
  },
  isByVisible: {
    type: Boolean,
    default: false,
    required: false,
  },
  isBackoffice: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()

const computedUpdatedAt = computed(() => (props.audit ? props.audit.created_at : props.updatedAt))
const resolvedDate = computed(() =>
  props.isBackoffice
    ? shortUsDate(computedUpdatedAt.value)
    : localShortDate(computedUpdatedAt.value),
)
const resolvedTime = computed(() =>
  props.isBackoffice
    ? shortUsTime(computedUpdatedAt.value)
    : localShortTime(computedUpdatedAt.value),
)
</script>
